import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import ClassificacaoMediaAlocacaoStore from "../stores/ClassificacaoMediaAlocacaoStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {Row, Col} from "reactstrap";
import {CustomBarChart} from "../../comum/components/CustomBarChart";

const FILTROS = ["AREA", "CENTRAL", "DIVISAO", "DEPARTAMENTO", "EMPRESA", "COMPETENCIA_MES_INICIO", "COMPETENCIA_MES_FIM", "SAZONALIDADE"];

@inject("store")
@DataWrapper
@observer
export class ClassificacaoMediaAlocacao extends Component {
    constructor(props) {
        super(props);
        this.controller = new ClassificacaoMediaAlocacaoStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Classificação de cargos pela média de alocação");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS} />
                        <Row>
                            <Col xs={12} md={12} lg={10}>
                                <CustomBarChart dataKeys={["Média alocação", "Média alocação corrigida"]}
                                        data={this.controller.dados} labelAxisX={"Cargo"} labelAxisY={"Média"} />
                            </Col>
                        </Row>
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
